import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import CatalogItem from '../models/helperTypes/CatalogItem';

/**
 * Returns a list of CatalogItems (the display entity) matching the provided array list
 *
 * @param itemArray - An array of general catalog items to map
 * @param valueKey - The value that will be used as 'Value'
 */
function mapToCatalogItem(
  itemArray: GeneralCatalogItem[],
  valueKey: 'code' | 'id' = 'code',
): CatalogItem[] {
  return itemArray.map(
    (item: GeneralCatalogItem): CatalogItem => ({
      Value: item[valueKey].toString(),
      Text: item.name,
      Object: item,
    }),
  );
}

export default mapToCatalogItem;
